import { get, post } from 'api/request';
import urls from 'configs/urls';

export const authenticateUser = ({ data }) =>
  post(null, true, urls.labsModuleUrls.accountManagementUrls.authenticateUser, data);

export const getLoginInfo = ({ userKey }) =>
  get(null, false, `${urls.labsModuleUrls.accountManagementUrls.getLoginInfo}/${userKey}`);
